import { IonCard, IonCardHeader, IonCardTitle, IonImg } from '@ionic/react';

import { mergeClassNames } from '@/utils/mergeClassNames';

import { useSensor } from '@/hooks/useSensor';

import BackgroundPattern from '@/assets/bg-pattern-sensorcard.svg';
import SensorImage from '@/assets/sensors/sensor.svg';

import styles from './SensorCard.module.css';

import { SensorCardCalibrating } from './SensorCardCalibrating';
import { SensorCardNotCalibrated } from './SensorCardNotCalibrated';
import { SensorCardSearching } from './SensorCardSearching';
import { SensorCardSkeleton } from './SensorCardSkeleton';

export enum SensorStatus {
  SKELETON = 'skeleton',
  SEARCHING = 'searching',
  CONNECTED_NOT_CALIBRATED = 'connectedNotCalibrated',
  CALIBRATING = 'calibrating',
}

interface SensorCardProps {
  title: string;
  sensorId: string;
  selected: boolean;
  onSelect: (id: string) => void;
  state: SensorStatus;
}

export const SensorCard = ({ sensorId, selected, onSelect, title, state }: SensorCardProps) => {
  const { batteryLevel, calibrationStatus } = useSensor(sensorId);

  if (state === SensorStatus.SKELETON || batteryLevel === undefined) {
    return <SensorCardSkeleton />;
  }

  return (
    <IonCard
      button
      className={mergeClassNames(styles.card, selected && styles.selected)}
      onClick={() => onSelect(sensorId)}>
      <div className={styles.content}>
        <IonCardHeader className={styles.header}>
          <IonCardTitle className={styles.title}>{title}</IonCardTitle>
        </IonCardHeader>

        {
          {
            [SensorStatus.SEARCHING]: <SensorCardSearching />,
            [SensorStatus.CONNECTED_NOT_CALIBRATED]: <SensorCardNotCalibrated batteryLevel={batteryLevel} />,
            [SensorStatus.CALIBRATING]: <SensorCardCalibrating calibrationStatus={calibrationStatus} />,
          }[state]
        }
      </div>

      {state === SensorStatus.CONNECTED_NOT_CALIBRATED && (
        <div className={styles.sensor}>
          <IonImg className={styles.sensorImage} src={SensorImage} />
          <IonImg className={styles.backgroundPattern} src={BackgroundPattern} />
        </div>
      )}
    </IonCard>
  );
};
